import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchConfig } from "../lib/api";

const ConfigContext = createContext({ ecommerceEnabled: false, loading: true, refresh: () => {} });

export const ConfigProvider = ({ children }) => {
  // Default to FALSE (request mode) — safe fallback if the config call fails.
  const [config, setConfig] = useState({ ecommerceEnabled: false, loading: true });

  const refresh = useCallback(
    () =>
      fetchConfig()
        .then((c) => setConfig({ ecommerceEnabled: !!c.ecommerce_enabled, loading: false }))
        .catch(() => setConfig({ ecommerceEnabled: false, loading: false })),
    []
  );

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <ConfigContext.Provider value={{ ...config, refresh }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => useContext(ConfigContext);
